import difference from 'lodash/difference';
import isNumber from 'lodash/isNumber';
import union from 'lodash/union';
import { all, put, takeEvery } from 'redux-saga/effects';

import { InfiniteScrollActions } from '../constants/InfiniteScroll';
import {
  getOffsetToFetchWith,
  getPagesToFetchBasedOnIndicesInView,
  getPagesToFetchBasedOnItemsInView,
} from '../lib/RandomAccessUtils';

function* onRandomAccessInfiniteScroll(action) {
  const {
    items,
    originalItems,
    firstVisibleIndex,
    lastVisibleIndex,
    dataFetcher,
    fetchingOffsets,
    apiLimit,
    totalCount,
    loadedPages,
    allParamsValid,
  } = action.payload;
  if (allParamsValid) {
    const totalPages = Math.ceil(totalCount / apiLimit);
    const pagesToFetchBasedOnItemsInView = getPagesToFetchBasedOnItemsInView(
      firstVisibleIndex,
      lastVisibleIndex,
      items,
      originalItems,
      totalPages,
      apiLimit,
    );
    const pagesToFetchBasedOnIndicesInView = getPagesToFetchBasedOnIndicesInView(
      firstVisibleIndex,
      lastVisibleIndex,
      totalPages,
      apiLimit,
    );
    const pagesToFetch = difference(
      union(pagesToFetchBasedOnItemsInView, pagesToFetchBasedOnIndicesInView),
      loadedPages,
    );
    yield all(
      pagesToFetch.map(page => {
        const fetchOffset = getOffsetToFetchWith(page, apiLimit);
        // don't make the api call if another api call with the same offset is already in flight
        if (!fetchingOffsets.includes(fetchOffset)) {
          return put(dataFetcher({ fetchOffset }));
        }
      }),
    );
  }
}

function* onInfiniteScroll(action) {
  const {
    items,
    dataFetcher,
    hasFetchedData,
    pageSize,
    listItemTotal,
    forceFetch,
    allParamsValid,
  } = action.payload;
  if (allParamsValid) {
    if (
      ((!isNumber(listItemTotal) || (isNumber(listItemTotal) && items.length < listItemTotal)) &&
        (hasFetchedData || (!hasFetchedData && items.length === 0))) ||
      forceFetch
    ) {
      yield put(
        dataFetcher({
          startIndex: forceFetch ? 0 : items.length,
          pageSize,
        }),
      );
    }
  }
}

export default function* infiniteScrollSaga() {
  yield all([
    takeEvery(InfiniteScrollActions.ON_RANDOM_ACCESS_INFINITE_SCROLL, onRandomAccessInfiniteScroll),
    takeEvery(InfiniteScrollActions.ON_INFINITE_SCROLL, onInfiniteScroll),
  ]);
}
